// extracted by mini-css-extract-plugin
export default {"textRight":"jut__ColumnAdapter__textRight","textLeft":"jut__ColumnAdapter__textLeft","textCenter":"jut__ColumnAdapter__textCenter"};